import { IonCard } from '@ionic/react';
import { ComponentProps, PropsWithChildren } from 'react';

import styles from '@/components/Cards/index.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

interface CardProps extends ComponentProps<typeof IonCard> {
  className?: string;
}

export const Card = ({ children, className, ...props }: PropsWithChildren<CardProps>) => {
  return (
    <IonCard className={mergeClassNames(styles.card, className)} {...props}>
      {children}
    </IonCard>
  );
};
